<mat-card class="popup-card">
  <mat-card-content>

    <!-- ====== toolbar vista ====== -->
    <div class="toolbar">
      <button mat-stroked-button [color]="viewMode==='planned' ? 'primary' : ''" (click)="switchTo('planned')">
        {{ 'PLANNER_RIEPILOGO.PLANNED_VIEW' | translate }}
      </button>

      <button mat-stroked-button [color]="viewMode==='absences' ? 'primary' : ''" (click)="switchTo('absences')">
        {{ 'PLANNER_RIEPILOGO.ABSENCES_VIEW' | translate }}
      </button>

      <button mat-stroked-button [color]="viewMode==='unplanned' ? 'primary' : ''" (click)="switchTo('unplanned')">
        {{ 'PLANNER_RIEPILOGO.UNPLANNED_VIEW' | translate}}
      </button>

    </div>

    <!-- ====== header info ====== -->
    <h3>{{ 'PLANNER_RIEPILOGO.DATE_LABEL' | translate }} {{ displayDate }}</h3>

    <!-- ====== VISTA: PIANIFICATI ====== -->
    <ng-container *ngIf="viewMode==='planned'">
      <p *ngIf="operators.length > 0">
        {{ 'PLANNER_RIEPILOGO.TOTAL_OPERATORS_PLANNED' | translate }} {{ uniqueOperatorCount }}
      </p>

      <div *ngIf="operators.length === 0" class="no-commesse" [innerHTML]="noOrdersMessage">
        {{ noOrdersMessage }}
      </div>

      <div *ngIf="operators.length > 0" class="scroll-container">
        <table mat-table [dataSource]="operators" class="mat-elevation-z8">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> {{ 'PLANNER_RIEPILOGO.NAME_COLUMN' | translate }} </th>
            <td mat-cell *matCellDef="let operator"> {{ operator.name }} </td>
          </ng-container>

          <ng-container matColumnDef="commessa">
            <th mat-header-cell *matHeaderCellDef> {{ 'PLANNER_RIEPILOGO.CODE_COLUMN' | translate }} </th>
            <td mat-cell *matCellDef="let operator">
              <div>{{ operator.commessa }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="hours">
            <th mat-header-cell *matHeaderCellDef> {{ 'PLANNER_RIEPILOGO.HOURS_COLUMN' | translate }} </th>
            <td mat-cell *matCellDef="let operator"> {{ operator.hours }} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </ng-container>

    <!-- ====== VISTA: ASSENZE (sempre compatta) ====== -->
    <ng-container *ngIf="viewMode==='absences'">
      <div *ngIf="compactRows.length === 0" class="no-commesse">
        {{ 'PLANNER_RIEPILOGO.NO_ABSENCES' | translate: {} : 'Nessuna assenza rilevata' }}
      </div>

      <div *ngIf="compactRows.length > 0" class="scroll-container">
        <table mat-table [dataSource]="compactRows" class="mat-elevation-z8 absences-table">

          <!-- Commessa -->
          <!-- Commessa -->
          <ng-container matColumnDef="order">
            <th mat-header-cell *matHeaderCellDef class="col-order"> {{ 'PLANNER_RIEPILOGO.CODE_COLUMN' | translate }}
            </th>
            <td mat-cell *matCellDef="let row" class="sticky-col col-order">
              <span class="code">{{ row.orderCode }}<br> <span class="span-txt">{{ row.building }}</span></span>
            </td>
          </ng-container>

          <!-- Operatore -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="col-name"> {{ 'PLANNER_RIEPILOGO.NAME_COLUMN' | translate }}
            </th>
            <td mat-cell *matCellDef="let row" class="col-name" [matTooltip]="row.name">{{ row.name }} <br> <span class="span-txt">{{ row.role }}</span></td>
          </ng-container>

          <!-- Causale -->
          <ng-container matColumnDef="causal">
            <th mat-header-cell *matHeaderCellDef class="col-causal"> {{ 'PLANNER_RIEPILOGO.CAUSAL' | translate }} </th>
            <td mat-cell *matCellDef="let row" class="col-causal">{{ row.causalCode }}</td>
          </ng-container>

          <!-- Ore -->
          <ng-container matColumnDef="hours">
            <th mat-header-cell *matHeaderCellDef class="col-hours"> {{ 'PLANNER_RIEPILOGO.HOURS_ABS' | translate }}
            </th>
            <td mat-cell *matCellDef="let row" class="col-hours">{{ row.hours }}</td>
          </ng-container>

          <!-- Periodi -->
          <ng-container matColumnDef="ranges">
            <th mat-header-cell *matHeaderCellDef class="col-ranges"> {{ 'PLANNER_RIEPILOGO.RANGES' | translate }} </th>
            <td mat-cell *matCellDef="let row" class="col-ranges">
              <div class="chips">
                <span class="chip" *ngFor="let r of row.ranges">
                  {{ formatYMDHeader(r.from) }} → {{ formatYMDHeader(r.to) }} <small>({{ r.days }}g)</small>
                </span>
              </div>
            </td>
          </ng-container>


          <tr mat-header-row *matHeaderRowDef="absenceDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: absenceDisplayedColumns;"></tr>
        </table>
      </div>

    </ng-container>

    <!-- ====== VISTA: NON PIANIFICATI ====== -->
    <ng-container *ngIf="viewMode==='unplanned'">
      <div *ngIf="unplannedRows.length === 0" class="no-commesse">
        {{ 'PLANNER_RIEPILOGO.NO_UNPLANNED' | translate: {} : 'Tutti pianificati nell’intervallo' }}
      </div>

      <div *ngIf="unplannedRows.length > 0" class="scroll-container">
        <table mat-table [dataSource]="unplannedRows" class="mat-elevation-z8">

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>{{ 'PLANNER_RIEPILOGO.NAME_COLUMN' | translate }}</th>
            <td mat-cell *matCellDef="let r">
              {{ r.name }}
            </td>
          </ng-container>

          <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef>{{ 'PLANNER_RIEPILOGO.ROLE_COLUMN' | translate }}</th>
            <td mat-cell *matCellDef="let r">
              <span class="role-badge" [ngClass]="roleCss(r.role)">{{ r.role }}</span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="unplannedDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: unplannedDisplayedColumns;"></tr>
        </table>
      </div>
    </ng-container>


  </mat-card-content>
</mat-card>